import { RootState } from 'store/rootReducer';

export const ContactSectionContentSelector = (state: RootState) => state.content.contactSection;
